// @flow

import * as React from "react";
import Tile from "../molecules/Tile";
import getContentReferenceTileProps from "../../utils/getContentReferenceTileProps";
import TicketDetailModal from "./TicketDetailModal";
import Loader from "../atoms/Loader";

type PropsType = {
    tickets: any,
    type: string,
    isLoading: boolean,
};

const TicketProfileBody = (props: PropsType): React.Node => {
    // let { id } = useParams();
    const [showTicketModal, setShowTicketModal] = React.useState(false);
    const [activeTicket, setActiveticket] = React.useState(-1);

    const selectTicketDetail = ticketId => {
        setActiveticket(ticketId);
        setShowTicketModal(true);
        // history.push(
        //     `${Config.routes.purchases}/${orderId}${document.location.search}`
        // );
    };

    // React.useEffect((): any => {
    //     let cancel = false;
    //     if (id) {
    //         API.userGetOrderDetails(id).then((data: any) => {
    //             if (!cancel) {
    //                 console.log(data);
    //                 setActiveOrderDetails(data);
    //                 setShowOrderModal(true);
    //             }
    //         });
    //     }
    // }, [id]);

    return (
        <div className="ticket-profile-body container-fluid">
            <div className="row">
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <div className="row">
                        <div className="col-xs-12">
                            <Loader active={props.isLoading}>
                                {props.tickets && props.tickets.length > 0 ? (
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div>
                                                Can't see your ticket? Give us
                                                2-3 mins and then refresh your
                                                page.
                                            </div>
                                            {props.tickets.map(
                                                (ticket, key) => {
                                                    const referenceContent =
                                                        getContentReferenceTileProps(
                                                            {
                                                                ...ticket,
                                                                acf: {},
                                                                type: "ticket",
                                                            }
                                                        );
                                                    return (
                                                        <div
                                                            key={key}
                                                            className="ticket-profile-body__content__row row"
                                                        >
                                                            <div className="col-md-12">
                                                                <Tile
                                                                    {...referenceContent}
                                                                    onClick={() =>
                                                                        selectTicketDetail(
                                                                            key
                                                                        )
                                                                    }
                                                                    isPastEvent={
                                                                        props.type ===
                                                                        "past"
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                ) : props.type === "past" ? (
                                    <div>
                                        You don't have any {props.type} tickets.
                                    </div>
                                ) : (
                                    <div>
                                        You have no {props.type} tickets. If
                                        you’ve just made a purchase, tickets can
                                        take a few minutes to appear.
                                    </div>
                                )}
                            </Loader>
                        </div>
                    </div>
                </div>
            </div>
            {activeTicket >= 0 ? (
                <TicketDetailModal
                    data={{
                        events: [
                            {
                                startDate:
                                    props.tickets[activeTicket]
                                        .event_start_date,
                                endDate:
                                    props.tickets[activeTicket].event_end_date,
                                eventName:
                                    props.tickets[activeTicket].event_name,
                                location:
                                    props.tickets[activeTicket].event_location,
                                tickets: props.tickets[
                                    activeTicket
                                ].tickets.map(({ qrcode_url }) => ({
                                    qrcodeUrl: qrcode_url,
                                })),
                            },
                        ],
                    }}
                    onClose={() => setShowTicketModal(false)}
                    active={showTicketModal}
                />
            ) : null}
        </div>
    );
};

export default TicketProfileBody;
